import { TelemedService } from './services/telemed.service';
import { SetCustomerAction } from "./statemanagement/action/customer.action";
import { Component, OnInit, ViewEncapsulation, Renderer2, Injector, signal, ChangeDetectionStrategy } from "@angular/core";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { take } from "rxjs/operators";
import { FormVerifyCustomerService } from "./services/form-verify-customer.service";
import { CheckRegisterAndValidateDataReference, ResponseCheckRegisterAndValidate, ResponseStateRegistration } from "./models/verify.model";
import { LoaderService } from "./services/loader.service";
import { ConcentService } from "./services/concent.service";
import { LineStateActionService } from "./statemanagement/line-state-action.service";
import { SetChannelAction } from "./statemanagement/action/channel.action";
import { Customer, Identity } from "./models/customer.model";
import { SetIdentityAction } from "./statemanagement/action/identity.action";
import { TitleService } from "./services/title.service";
import { TrackingIDService } from "./services/tracking-id.service";
import { environment } from "../../../environments/environment";
import { LoggerService } from "./services/logger.service";
import { MaintainanceService } from "./services/maintainance.service";
import { encryptData } from '../../core/utilities';
// import { NavigatorService } from './statemanagement/navigator.service';
import {
  ActionStatus,
  ResponseStatus,
  TermsAndCondition,
} from "./models/termAndCondition.model";
import {
  ActionStatusLine,
  ResponseStatusLine,
  TermsAndConditionLine,
} from "./models/termAndConditionLine.model";
import { Channel } from "./models/channel.model";
import { TermsAndConditionService } from "./services/terms-and-condition.service";
import { CommonService } from "./services/common.service";
import { LineNotificationService } from "./services/line-notification.service";
import { Observable } from "rxjs";
import { TelemedStateActionService } from "./statemanagement/telemed-state-action.service"
import { FormAdditionalServiceRegistrationService } from "./services/form-additional-service-registration.service"
import { VerifyReferenceService } from './services/verify-reference.service';
import { BaseComponents } from '../../base.component';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
import liff from '@line/liff';
declare var UIkit: any;
declare var window: any;
@Component({
    selector: "app-line",
    templateUrl: "./line.component.html",
    styleUrls: ["./line.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LineComponent extends BaseComponents implements OnInit {
  log_session_text: string = 'linecomponent';
  themeCode = signal<string>('');
  liffId: string;
  lineId: string;
  chanelId: string;
  next = signal<boolean>(false);
  displayLayout: boolean = true;
  loader: Observable<boolean>;
  comCode: string;
  liffUrl: string;
  isLocation: any;
  title: any = {
    insure: "TISCO Insure",
    mazda: "Mazda Premium Insurance",
    ford: "Ford Ensure",
    mitsu: "Mitsubishi Motor Insurance",
    nissan: "Nissan Insure",
    prim: "Prime Insure",
    lpp: "LPP Insure",
    gwm: "GWM Smart Drive"
  };
  electronic: number;
  lineBotId: string;
  appNo: number;
  registerFlow: string;
  state: string = "";
  substate: string = "";
  ref: string = "";
  liff_motor: string = "";
  classify_insure: number;
  flow: number;
  rm_channel_id: number;
  octp_channel_id: number;
  buyInsuranceOnlineClosedFlag = signal<boolean>(false);
  buyInsuranceOnlineClosedDesc = signal<string>('');
  referenceUUID = signal<string>(null);
  showReference: boolean = false;
  private claimObj: { accident_no, service_location };
  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private verifyCustomerService: FormVerifyCustomerService,
    private router: Router,
    private loaderService: LoaderService,
    private concentService: ConcentService,
    private lineStateAction: LineStateActionService,
    private titleService: TitleService,
    private trackingService: TrackingIDService,
    private loggerService: LoggerService,
    private termsAndConditionService: TermsAndConditionService,
    private commonService: CommonService,
    private maintainanceService: MaintainanceService,
    private telemedStateActionService: TelemedStateActionService,
    private formAdditionalServiceRegistration: FormAdditionalServiceRegistrationService,
    private telemedService: TelemedService,
    private verifyReferenceService: VerifyReferenceService,
    private referenceService:ReferenceService,
    public getMaskingService:GetMaskingService
  ) {
    super(injectorObj);
  }

  async ngOnInit() {

    const funcName = 'ngOnInit'
    this.referenceUUID.set(this.referenceService.getReferenceUUID());
    this.referenceService.showReference$.subscribe((showReference) => {
      this.showReference = showReference;
    });
    this.log_session_text = `linecomponent referenceUUID:[${this.referenceUUID}]`
    this.logger.info(`${this.log_session_text}:${funcName}:start`);

    if (environment.log_level == "debug") { window.vConsole = new window.VConsole(); }

    this.logger.info(`${this.log_session_text}:${funcName}:setMaintainance`);
    
    if (await this.setMaintainance()) return;
    if (this.router.url.indexOf('/completed') != -1) {
      this.logger.info(`${this.log_session_text}:${funcName} url /completed`);
      this.next.set(true);
    } else {
      this.logger.info(`${this.log_session_text}:${funcName} url other`);
      this.next.set(false);
    }

    this.logger.info(`${this.log_session_text}:${funcName}:renderer`);
    
    this.trackingService.geaneratetracking();
    this.loader = this.loaderService.loadingObservable;
    this.route.paramMap.pipe(take(1)).subscribe((params) => {
      this.themeCode.set(params.get("comcode") || "insure")
      this.logger.info(`${this.log_session_text}:${funcName}:themeCode is ${this.themeCode()}`);

      this.renderer.addClass(document.querySelector("#insure"), this.themeCode());
    });

    this.logger.info(`${this.log_session_text}:${funcName}:getParams`);

    try {
      this.getParams().then(channel => {
        this.logger.info(`${this.log_session_text}:${funcName}:getParams start`);
        if (!!channel == false) return;
        this.logger.info(`${this.log_session_text}:${funcName}:chanelId:${this.chanelId}`);
        this.logger.info(`${this.log_session_text}:${funcName}:electronic:${this.electronic}`);

        if (this.chanelId && this.electronic) {
          this.logger.info(`${this.log_session_text}:${funcName}:getFriendShip`);
          this.getFriendShip();

          this.logger.info(`${this.log_session_text}:${funcName}:verifyRegister`);
          this.verifyRegister(this.chanelId, this.electronic);
        }

      });
    } catch (err) {
      this.logger.error(`${this.log_session_text}:error:${err.message ? err.message : err}`);
    }
    Observable.forkJoin(
      this.lineStateAction.observableChannel,
      this.lineStateAction.observableIdentity,
      this.lineStateAction.observableCustomer
    ).subscribe();

  }

  getFriendShip() {
    const funcName = 'getFriendShip'
    return new Promise((resolve, reject) => {
      this.logger.info(`${this.log_session_text}:${funcName}:start`);
      try {
        liff.getFriendship().then((result: any) => {
          this.logger.info(`${this.log_session_text}:${funcName}:getFriendship start`)
          this.logger.info(`${this.log_session_text}:${funcName}:${JSON.stringify(result)}`)
          return resolve(result.friendFlag)
        }).catch(error => {
          this.logger.info(`${this.log_session_text}:${funcName}:error1:${error.message ? error.message : error}`)
          return resolve(false)
        });
      } catch (error) {
        this.logger.error(`${this.log_session_text}:${funcName}:error2:${error.message ? error.message : error}`)
        return resolve(false)
      }
    })

  }

  mockLineId() {
    // mock localhost
    // return "Ubf88e9acc21dd5688f18352c5f61c4a4" //insure
    // return "Uc4a8240e7361e83a31ed9a5adac44c1c" //ford
    // return "Ufc71ea69a9b627e5adac8ccc91921cd1" //mazda
    // return "U39084cbc4181767ac27967572e5286a4" //nissan
    return "Ued0838065ca70ecf78dc3f7f7cd1f918" //mazda Boss
    // return "U0289b2b557bec536864988824e6175b4" //insure pap
    // return "U12a822611d8bf3a91d4fe2e65cfffcf3" //ford Boss
    // return "U8fdf48fe3e4e4246911ad23efd974520" //nissan boss
  }

  getParams(): Promise<Channel> {
    const funcName = 'getParams'
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    return new Promise(async (resolve, reject) => {
      this.loggerService.loggerInfo({ line: "line ngOnInit start getParams" }).subscribe();
      let channel = this.lineStateAction.channelStateInfo;
      this.route.params.subscribe(async (params) => {
        this.comCode = params.comcode;
        this.titleService.setTitle(this.title[this.comCode] + ": ลงทะเบียน");
      });
      this.route.queryParams.take(1).subscribe(async (queryParams) => {
        this.logger.info(`${this.log_session_text} ${funcName} query params: ${JSON.stringify(queryParams)}`);
        const { session_ref, termsandcondition, termandconditionid, appRef, electronic_channel,
          lineId, connectRef, location, lineBotId, app_no, subchannel, ref, mega, flow, subflow, history, accident_no, service_location, addTag, lineTemplate,
          app_code, prod, port, rm_channel_id, octp_channel_id, dazDoctor, dazSpecialty, message, liff_portfolio, campaign } = queryParams;
        this.getMappingRegisterFlow(flow || app_no).then(
          async (registerFlow) => {
            if (session_ref) {
              this.logger.info(`${this.log_session_text} ${funcName} is session ref`);
              this.getSessionRef(session_ref);
              channel = this.lineStateAction.channelStateInfo;
            }
            if (termsandcondition == "success") {
              this.logger.info(`${this.log_session_text} ${funcName} termsandcondition success`);
              const params = {
                termsandcondition: termsandcondition,
                termandconditionid: termandconditionid,
                electronic_channel: electronic_channel,
                appRef: appRef,
                lineId: lineId,
                connectRef: connectRef,
                location: location,
                lineBotId: lineBotId,
                rm_channel_id: rm_channel_id,
                octp_channel_id: octp_channel_id
              }
              channel = await this.setTermsAndConditionParams(params);
              // channel = this.lineStateAction.channelStateInfo;
              this.logger.info(`${this.log_session_text} ${funcName} end`);
              return resolve(channel);
            }
            if (appRef) {
              this.logger.info(`${this.log_session_text} ${funcName} is app ref`);
              this.electronic = +electronic_channel;
              this.liffId = appRef;
              this.lineId = lineId;
              this.liffUrl = (channel && channel.liffUrl) ? channel.liffUrl : window.location.href;
              this.chanelId = connectRef; // channel id จาก line developer
              this.isLocation = location;
              this.lineBotId = lineBotId;
              this.ref = queryParams.ref;
              this.liff_motor = queryParams.liffmotor;
              this.flow = parseInt(queryParams.flow)
              this.classify_insure = queryParams.classify_insure;
              this.rm_channel_id = rm_channel_id;
              this.octp_channel_id = octp_channel_id;
              try {
                // if (typeof liff != "undefined" && liff) {
                //   this.loggerService.loggerInfo({ line: "get profile from liff start" }).subscribe();
                //   try {
                //     const isLogin = await this.initializeLiff(this.liffId);
                //     // if (!isLogin) return resolve(channel);
                //   } catch (error) {
                //     this.logger.error(['get line liff error',error]);
                //     console.error("get line liff error");
                //   }
                //   this.loggerService.loggerInfo({ line: "get profile from liff end" }).subscribe();
                // } else {
                //   console.error("liff is undefined");
                //   this.logger.error("liff is undefined");
                // }
                // if (!this.lineId) {
                //   if (environment.mode == "alpha") {
                //     this.lineId = this.mockLineId();
                //   }
                // }

                this.claimObj = { accident_no: accident_no, service_location: service_location }
                const friendshipFlag = await this.getFriendShip();
                channel = {
                  ...(channel || {}),
                  electronic_channel: this.electronic,
                  // channel_identity: this.lineId,
                  channel_identity: "##channel_identity##",
                  application_channel_reference: connectRef,
                  comCode: this.comCode,
                  liffId: this.liffId,
                  liffUrl: this.liffUrl,
                  isLocation: this.isLocation,
                  lineBotId: this.lineBotId,
                  accident_no: accident_no,
                  appNo: app_no as number,
                  subChannel: subchannel,
                  refCode: ref,
                  registerFlow: registerFlow,
                  branded: mega,
                  subflow: subflow,
                  flow: flow,
                  addTag: addTag,
                  lineTemplate: lineTemplate,
                  appCode: app_code,
                  port: port,
                  prod: prod,
                  friendshipFlag: friendshipFlag,
                  rm_channel_id: rm_channel_id,
                  octp_channel_id: octp_channel_id,
                  dazDoctor: dazDoctor,
                  dazSpecialty: dazSpecialty,
                  message: message,
                  liff_portfolio: liff_portfolio,
                  campaign: campaign
                } as Channel;

                this.telemedStateActionService.setLineInfo({
                  ...this.telemedStateActionService.lineInfo || {},
                  history: history,
                })
                this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
                this.logger.info(`${this.log_session_text} ${funcName} end`);
                return resolve(channel);
              } catch (err) {
                this.logger.error(`${this.log_session_text} ${funcName} error: ${err.message ? err.message : err}`);
                this.loggerService.loggerInfo({ line: "error getParam liff" }).subscribe();
                return reject(err);
              }
            }


          }
        );

      });

    })
  }

  getMappingRegisterFlow(flow): Promise<string> {
    const funcName = 'getMappingRegisterFlow'
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    return new Promise((resolve,reject) => {
      if (this.registerFlow) {
        this.logger.info(`${this.log_session_text} ${funcName} flow*: ${JSON.stringify(this.registerFlow)}`);
        return resolve(this.registerFlow);
      }
      if (!flow) return resolve("");

      const request = { description: "RegisterMapingFlow", id: null };
      this.commonService.apiGetCommonConfig(request).subscribe(
        (response) => {
          if (response && response.data) {
            const jsonParse = JSON.parse(response.data.value);
            if (jsonParse && jsonParse[flow]) {
              const result = jsonParse[flow].toLowerCase();
              this.registerFlow = result;
              this.logger.info(`${this.log_session_text} ${funcName} flow**: ${JSON.stringify(this.registerFlow)}`);
              this.logger.info(`${this.log_session_text} ${funcName} end`);
              return resolve(result);
            }
          }
        },
        (error) => {
          this.logger.error(`${this.log_session_text} ${funcName} get common config error: ${error.message ? error.message : error}`);
          return reject(error)
        }
      );
    });
  }

  async setTermsAndConditionParams(params) {
    const funcName = "setTermsAndConditionParams"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    if (params["termsandcondition"] == "success") {
      let channel = this.lineStateAction.channelStateInfo;
      if (channel?.termsAndCondition && channel?.termsAndCondition.status == ResponseStatus.SKIP) {
        let responseTermsAndCondition = {
          status: "success",
          action: "accept",
          termConditionId: params["termandconditionid"],
        } as TermsAndCondition;
        channel.termsAndCondition = responseTermsAndCondition;
      }
      if (channel?.termsAndConditionLine && channel?.termsAndConditionLine.status == ResponseStatusLine.SKIP) {
        let responseTermsAndConditionLine = {
          status: "success",
          action: "accept",
          termConditionId: params["termandconditionid"],
        } as TermsAndConditionLine;
        channel.termsAndConditionLine = responseTermsAndConditionLine;
      }
      this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
      this.comCode = channel.comCode;
      this.electronic =
        +params.electronic_channel || channel.electronic_channel;
      this.liffId = params.appRef;
      // this.lineId = params.lineId || channel.channel_identity;
      this.liffUrl = channel.liffUrl || window.location.href;
      this.chanelId = params.connectRef; // channel id จาก line developer
      this.isLocation = params.location;
      this.lineBotId = params.lineBotId;
      this.rm_channel_id = params.rm_channel_id;
      this.logger.info(`${this.log_session_text} ${funcName} end`);
      return channel;
    }
  }

  getSessionRef(sessionRef) {
    const funcName = "getSessionRef"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    // const sessionRef = queryParams["session_ref"];
    const json = JSON.parse(sessionStorage.getItem(sessionRef));
    if (json["channel"] && json["channel"] != "null") {
      const channel = json["channel"] as Channel;
      this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
    }
    if (json["identity"] && json["identity"] != "null") {
      const identity = json["identity"] as Identity;
      this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
    }
    if (json["customer"] && json["customer"] != "null") {
      const customer = json["customer"] as Customer;
      this.lineStateAction.sinkCustomer.next(new SetCustomerAction(customer));
    }
    if (json["substate"] && json["substate"] != "null") {
      this.substate = json["substate"];
    }
    if (json["telemed"] && json["telemed"] != "null") {
      this.telemedStateActionService.setLineInfo(json["telemed"]);
    }
    if (json["ref"] && json["ref"] != "null") {
      this.ref = json["ref"];
    }
    if (json["liff_motor"] && json["liff_motor"] != "null") {
      this.liff_motor = json["liff_motor"];
    }
    if (json["flow"] && json["flow"] != "null") {
      this.flow = json["flow"];
    }
    if (json["classify_insure"] && json["classify_insure"] != "null") {
      this.classify_insure = json["classify_insure"];
    }
    if (json["claimObj"] && json["claimObj"] != "null") {
      this.claimObj = json["claimObj"];
    }
    Observable.forkJoin(
      this.lineStateAction.observableChannel,
      this.lineStateAction.observableIdentity,
      this.lineStateAction.observableCustomer
    ).subscribe();
    this.logger.info(`${this.log_session_text} ${funcName} end`);
  }

  // async initializeLiff(myLiffId) {
  //   try {   
  //     await liff.init({ liffId: myLiffId });
  //     if (liff.isLoggedIn() == false && liff.isInClient() == false) {
  //       // liff.login({ redirectUri: window.location.href });
  //       return false;
  //     }
  //     const profile: any = await liff.getProfile();
  //     this.lineId = profile.userId;
  //   } catch (err) {
  //     // const js_msg = JSON.stringify(err);
  //     this.loggerService.loggerInfo({ line: "error initializeLiff start" }).subscribe();
  //     throw err;
  //   }
  //   return true;
  // }

  async verifyRegister(chanelId, electronic) {
    const funcName = 'verifyRegister'
    // this.logger.info("verify register line id: " + lineId);  
    this.logger.info(`${this.log_session_text} ${funcName} started`)
    const payload = {
      // channel_identity: lineId,
      application_channel_reference: chanelId,
      electronic_channel: electronic,
    };
    this.logger.info(`${this.log_session_text} ${funcName} payload:${JSON.stringify(payload)}`)
    this.verifyCustomerService.apiVerifyRegistration(payload).take(1).subscribe(async (result) => {
    this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration response start`)
      if (!result) return;
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration have response`)
      const registerStatus = result.state_code;
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration registerStatus:${registerStatus}`)
      const customer_id = result['_1'];
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration customer_id:${customer_id}`)
      const idNo = result.data != null ? result.data.id_card : "";
      const log_idNo = this.getMaskingService.maskingData(idNo)
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration idNo:${log_idNo}`)
      let channel = this.lineStateAction.channelStateInfo;
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration channel:${JSON.stringify(channel)}`)
      // "_11767": "RegisterMapingFlow",
      // "_11769": "{\"none\":\"Normal\",\"271\":\"Short\",\"272\":\"telemed\"}",
      this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration channel.registerFlow:${channel.registerFlow}`)
      if (channel.registerFlow === "telemed") {
        this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration flowTelemed start`)
        await this.flowTelemed(registerStatus, customer_id);
        this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration flowTelemed end`)
        return;
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration flowDefault start`)
        await this.flowDefault(registerStatus, customer_id, idNo);
        this.next.set(true);
        this.logger.info(`${this.log_session_text} ${funcName} apiVerifyRegistration flowDefault end`)
        return;
      }
    });
  }

  isOpenConsent(): boolean {
    const funcName = "isOpenConsent"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    const channel = this.lineStateAction.channelStateInfo;
    if ((channel && (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") && channel.comCode == "insure") ||
      (channel.registerFlow != "short" && this.substate != "consent" && this.flow != 2)) {
      this.substate = "consent";
      this.logger.info(`${this.log_session_text} ${funcName} true`);
      this.logger.info(`${this.log_session_text} ${funcName} end`);
      return true;
    }
    this.logger.info(`${this.log_session_text} ${funcName} false`);
    this.logger.info(`${this.log_session_text} ${funcName} end`);
    return false;
  }

  isOpenTermsAndCondition(): boolean {
    const funcName = "isOpenTermsAndCondition"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    const channel = this.lineStateAction.channelStateInfo;
    if (channel && !channel.termsAndCondition && channel.registerFlow == "telemed") {
      this.logger.info(`${this.log_session_text} ${funcName} condition 1: (channel && !channel.termsAndCondition && channel.registerFlow == "telemed")`);
      return true;
    }
    if (channel && !channel.termsAndCondition) {
      this.logger.info(`${this.log_session_text} ${funcName} condition 2: (channel && !channel.termsAndCondition)`);
      return true
    };
    this.logger.info(`${this.log_session_text} ${funcName} condition 3: (else)`);
    return false;
  }

  isOpenTermsAndConditionLine(): boolean {
    const funcName = "isOpenTermsAndConditionLine"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    const channel = this.lineStateAction.channelStateInfo;
    if (channel && !channel.termsAndConditionLine && channel.registerFlow == "telemed") {
      this.logger.info(`${this.log_session_text} ${funcName} condition 1: (channel && !channel.termsAndConditionLine && channel.registerFlow == "telemed")`);
      return true
    };
    if (channel && !channel.termsAndConditionLine) {
      this.logger.info(`${this.log_session_text} ${funcName} condition 2: (channel && !channel.termsAndConditionLine)`);
      return true;
    }
    this.logger.info(`${this.log_session_text} ${funcName} condition 3: (else)`);
    return false;
  }

  createUpdateTermAndCondition(identityUcid = null): Promise<boolean> {
    const funcName = 'createUpdateTermAndCondition'
    return new Promise((resolve, reject) => {
      this.logger.info(`${this.log_session_text} ${funcName} started`)
      const channel = this.lineStateAction.channelStateInfo;
      let body = {
        comcode: channel.comCode,
        // channel_identity: channel.channel_identity,
        electronic_channel: channel.electronic_channel,
        application_channel_reference: channel.application_channel_reference,
        app_no: channel.appNo,
        term_and_condition_id: channel.termsAndCondition ? channel.termsAndCondition.termConditionId : null,
        identity_ucid: identityUcid,
      };
      let log_body = {
        ...body,
        identity_ucid: this.getMaskingService.maskingData(identityUcid)
      }
      this.logger.info(`${this.log_session_text} ${funcName} log_body:${JSON.stringify(log_body)}`);
      this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(async (result) => {
      this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition response:${result?.response_code}`);
        if (result && result.response_code == "40000") {
          this.logger.info(`${this.log_session_text} ${funcName} create or update success: ${JSON.stringify(result)}`);
          channel.termsAndCondition.status = ResponseStatus.COMPLETED;
          this.logger.info(`${this.log_session_text} ${funcName} end`)
          return resolve(true);
        }
        this.logger.info(`${this.log_session_text} ${funcName} end`)
        return resolve(false);
      });
    })
  }

  createUpdateTermAndConditionLine(identityUcid = null): Promise<boolean> {
    const funcName = 'createUpdateTermAndConditionLine'
    return new Promise((resolve, reject) => {
      this.logger.info(`${this.log_session_text} ${funcName} started`)
      const channel = this.lineStateAction.channelStateInfo;
      let body = {
        comcode: channel.comCode,
        // channel_identity: channel.channel_identity,
        electronic_channel: channel.electronic_channel,
        application_channel_reference: channel.application_channel_reference,
        app_no: channel.appNo,
        term_and_condition_id: channel.termsAndConditionLine ? channel.termsAndConditionLine.termConditionId : null,
        identity_ucid: identityUcid,
        //check t&c line 
        terms_and_condition_flag: true
      };
      this.logger.info(`${this.log_session_text} ${funcName} body:${JSON.stringify(body)}`);
      this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(async (result) => {
        this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition result: ${JSON.stringify(result)}`);
        if (result && result.response_code == "40000") {
          this.logger.info(`${this.log_session_text} ${funcName} create_or_update_success_line: ${JSON.stringify(result)}`);
          channel.termsAndConditionLine.status = ResponseStatusLine.COMPLETED;
          this.logger.info(`${this.log_session_text} ${funcName} end`)
          return resolve(true);
        }
        this.logger.info(`${this.log_session_text} ${funcName} end`)
        return resolve(false);
      });
    })
  }

  /**
   * 
   * @param customerInfo {id_card,firstname,lastname}
   * @returns 
   */
  callConcent(customerInfo = null): Promise<boolean> {
    const funcName = 'callConcent'
    return new Promise(async (resolve, reject) => {
      this.logger.info(`${this.log_session_text} ${funcName} started`);
      const cust_type = this.state == "pre-register" ? 2 : 1;
      const session_ref = new Date().valueOf();
      const channel = this.lineStateAction.channelStateInfo;
      let body = {
        comcode: channel.comCode,
        cust_type: cust_type,
        line_channel_id: channel.application_channel_reference,
        // line_user_id: channel.channel_identity,
        electronic_channel: channel.electronic_channel,
        liff_id: channel.liffUrl,
        session_ref: session_ref,
        branded: channel.branded,
        flow_name: channel.registerFlow
      };
      this.logger.info(`${this.log_session_text} ${funcName} body:${body}`);
      if (customerInfo) {
        body["id_no"] = customerInfo.id_card;
        body["first_name"] = customerInfo.first_name;
        body["last_name"] = customerInfo.last_name;
        this.logger.info(`${this.log_session_text} ${funcName} id_no:${this.getMaskingService.maskingData(customerInfo.id_card)}`);
        this.logger.info(`${this.log_session_text} ${funcName} first_name:${this.getMaskingService.maskingData(customerInfo.first_name)}`);
        this.logger.info(`${this.log_session_text} ${funcName} last_name:${this.getMaskingService.maskingData(customerInfo.last_name)}`);
      }
      this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl start`);
      await this.concentService.apiConcentUrl(body).subscribe((result) => {
      this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl response`);
        if (result && result.data && result.data.token_url) {
          this.logger.info(`${this.log_session_text} ${funcName} apiConcentUrl have token_url`);
          this.setSessionStorage(session_ref);
          window.location.href = result.data.token_url;
          this.logger.info(`${this.log_session_text} ${funcName} end`)
          return resolve(true);
        }
        this.logger.info(`${this.log_session_text} ${funcName} consent result: ${JSON.stringify(result)}`);
        this.logger.info(`${this.log_session_text} ${funcName} end`)
        return resolve(false);
      })
    });
  }

  callTermsAndCondition(params = null): Promise<any> {
    const funcName = 'callTermsAndCondition'
    return new Promise((resolve, reject) => {
      this.logger.info(`${this.log_session_text} ${funcName} started`);
      const channel = this.lineStateAction.channelStateInfo;
      let forceOpen = null;
      let terms_and_condition_name = null;
      if (params) {
        forceOpen = params['forceOpen'];
        terms_and_condition_name = params['terms_and_condition_name'];
      }
      const session_ref = new Date().valueOf()
      let requestBody = {
        ...channel,
        "terms_and_condition_name": terms_and_condition_name,
        "terms_and_condition_flag": false,
        "lead_reference_number": channel.refCode,
        "session_ref": session_ref
      }

      // if (forceOpen) {
      //   // requestBody["channel_identity"] = "forceOpen";
      //   requestBody["terms_and_condition_flag"] = true;
      //   requestBody["lead_reference_number"] = "";
      // }
      this.logger.info(`${this.log_session_text} ${funcName} apiCheckTermsAndCondition requestBody: ${JSON.stringify(requestBody)}`);
      this.termsAndConditionService.apiCheckTermsAndCondition(requestBody).subscribe(
        result => {
          if (result && result.response_code == "40000") {
            if (result.payload.token_url) {
              channel.termsAndCondition = { status: "skip" } as TermsAndCondition
              this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
              this.setSessionStorage(session_ref);
              window.location.href = result.payload.token_url;
              // console.log('result.payload.token_url',result.payload.token_url)
              this.logger.info(`${this.log_session_text} ${funcName} end`)
              return resolve(result.payload.token_url)
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} end`)
          return resolve(null);
        },
        error => {
          this.logger.error(`${this.log_session_text} ${funcName} check terms and condition error: ${error.message ? error.message : error}`);
          this.logger.info(`${this.log_session_text} ${funcName} end`)
          return reject('check terms and condition error');
        }
      );
    });
  }

  callTermsAndConditionLine(params = null): Promise<any> {
    const funcName = 'callTermsAndConditionLine'
    return new Promise((resolve, reject) => {
      this.logger.info(`${this.log_session_text} ${funcName} started`);
      const channel = this.lineStateAction.channelStateInfo;
      let forceOpen = null;
      let terms_and_condition_name = null;
      if (params) {
        forceOpen = params['forceOpen'];
        terms_and_condition_name = params['terms_and_condition_name'];
      }
      const session_ref = new Date().valueOf()
      let requestBody = {
        ...channel,
        "terms_and_condition_name": terms_and_condition_name,
        "lead_reference_number": channel.refCode,
        "session_ref": session_ref,
        "terms_and_condition_line_flag": true
      }


      if (forceOpen) {
        // requestBody["channel_identity"] = "forceOpen";
        requestBody["terms_and_condition_flag"] = true;
        requestBody["lead_reference_number"] = "";
      }
      let log_requestBody = {
        ...requestBody,
        lead_reference_number : this.getMaskingService.maskingData(requestBody.lead_reference_number)
      }
      this.logger.info(`${this.log_session_text} ${funcName} apiCheckTermsAndConditionLine requestBody: ${JSON.stringify(log_requestBody)}`);
      this.termsAndConditionService.apiCheckTermsAndCondition(requestBody).subscribe(
        result => {
          this.logger.info(`${this.log_session_text} ${funcName} apiCheckTermsAndConditionLine response_code:${result?.response_code}`);
          if (result && result.response_code == "40000") {
            if (result.payload.token_url) {
              channel.termsAndConditionLine = { status: "skip" } as TermsAndConditionLine
              this.lineStateAction.sinkChannel.next(new SetChannelAction(channel));
              this.setSessionStorage(session_ref);
              window.location.href = result.payload.token_url;
              // console.log('result.payload.token_url',result.payload.token_url)
              this.logger.info(`${this.log_session_text} ${funcName} have token url`);
              this.logger.info(`${this.log_session_text} ${funcName} end`);
              return resolve(result.payload.token_url)
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} end`);
          return resolve(null);
        },
        error => {
          this.logger.error(`${this.log_session_text} ${funcName} apiCheckTermsAndCondition error: ${error.message ? error.message : error}`)
          return reject('check terms and condition | line error');
        }
      );
    });
  }

  async flowDefault(registerStatus: string, customerUuid: string, idNo: string) {
    const funcName = 'flowDefault';
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    let channel = this.lineStateAction.channelStateInfo as any;
    channel.electronic_channel = channel.electronic_channel;
    this.logger.info(`${this.log_session_text} ${funcName} register flow default`);
    this.logger.info(`${this.log_session_text} ${funcName} register flow default channel: ${JSON.stringify(channel)}`);
    let registerType = null;
    let res_verfify = null;
    if (registerStatus == ResponseStateRegistration.REGISTERED_ALREADY) registerType = 1;
    else if (registerStatus == ResponseStateRegistration.PRE_REGISTERED) registerType = 2;
    else if (registerStatus == ResponseStateRegistration.NOT_REGISTERED) registerType = 3;
    channel.registerType = registerType;
    this.logger.info(`${this.log_session_text} ${funcName} register type: ${registerType}`)
    if (channel.refCode) {
      this.logger.info(`${this.log_session_text} ${funcName} channel.refCode start`)

      channel.identityId = customerUuid;
      const log_customer_id = this.getMaskingService.maskingData(customerUuid)
      this.logger.info(`${this.log_session_text} ${funcName} channel.identityId:${log_customer_id}`)
      let requestBody: CheckRegisterAndValidateDataReference = {
        // channel_identity: channel.channel_identity,
        application_channel_reference: channel.application_channel_reference,
        electronic_channel: channel.electronic_channel,
        ref_code: channel.refCode,
        register_type: channel.registerType,
        identity_id: channel.identityId,
        subchannel: channel.subChannel
      }
      const log_requestBody = {
        ...requestBody,
        identity_id: this.getMaskingService.maskingData(requestBody.identity_id)
      }
      this.logger.info(`${this.log_session_text} ${funcName} apicheckRegisterAndValidateDataReference request body:${JSON.stringify(log_requestBody)}`)

      // this.logger.info("request body", requestBody)
      let verify_ref_result = await this.verifyReferenceService.apicheckRegisterAndValidateDataReference(requestBody).toPromise()
      // this.logger.info("result", verify_ref_result)
      res_verfify = verify_ref_result.state_code
      this.logger.info(`${this.log_session_text} ${funcName} apicheckRegisterAndValidateDataReference res_verfify:${res_verfify}`)
    }
    switch (registerStatus) { // กรณียังไม่ register แก้ที่นี่
      case ResponseStateRegistration.REGISTERED_ALREADY: {  //registerType = 1
        this.state = "register";
        this.logger.info(`${this.log_session_text} ${funcName} register flow register`);
        if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_SMS) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow register unmatch in case sms`);
          await this.router.navigate(["./formFail"], { relativeTo: this.route, queryParams: { "status": "fail", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_SMS } })
          break;
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} register case else`)
          if (channel.registerFlow == "claim" && this.claimObj) {
            this.logger.info(`${this.log_session_text} ${funcName} claim flow`)
            let getConsent = sessionStorage.getItem('consent');
            if ((getConsent !== undefined && getConsent !== null && getConsent == "1") || channel.refCode) {
              this.logger.info(`${this.log_session_text} ${funcName} register flow claim have consent`);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: 'success' } });
            } else {
              if (channel['flow'] == "4" && (channel['subflow'] == "3" || channel['subflow'] == "4")) {
                try {
                  this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment start`);
                  const body_checkCarCenterForAppointment = {
                      service_location_id: this.claimObj.service_location,
                      accident_no: this.claimObj.accident_no,
                      // channel_identity:channel.channel_identity,
                      electronic_channel: channel.electronic_channel,
                      comcode: channel.comCode,
                      rm_channel_id: channel.rm_channel_id,
                      subflow: channel['subflow']
                  }
                  this.logger.info(`${this.log_session_text} ${funcName} register flow claim body_checkCarCenterForAppointment:${JSON.stringify(body_checkCarCenterForAppointment)}`);
                  const checkCarCenterOpen = await this.verifyCustomerService.checkCarCenterForAppointment(body_checkCarCenterForAppointment).toPromise()
                  this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment response:${JSON.stringify(checkCarCenterOpen)}`);
                  if (checkCarCenterOpen) {
                    this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment checkCarCenterOpen:true`);
                    if (checkCarCenterOpen.data.statusAllow) {
                      this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment statusAllow:true`);
                      if (checkCarCenterOpen.data.dealer_type == 1) {
                      this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment dealer_type:1 goto page claimForm`);
                        this.router.navigate(["./claimForm"], { relativeTo: this.route, queryParams: { accident_no: this.claimObj.accident_no, service_location: this.claimObj.service_location, liffId: this.liffId } })
                      } else {
                        this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment dealer_type:other close liff`);
                        liff.closeWindow();
                      }
                    } else {
                      this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment statusAllow:false close liff`);
                      liff.closeWindow();
                    }
                  } else {
                    this.logger.info(`${this.log_session_text} ${funcName} register flow claim checkCarCenterForAppointment checkCarCenterOpen:false goto page completed status fail`);
                    this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "apifail", "code": "" } })
                  }
                } catch (err) {
                  this.logger.error(`${this.log_session_text} ${funcName} checkCarCenterForAppointment error `, err?.message)
                  this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "apifail", "code": "" } })
                }
              } else {
                this.logger.error(`${this.log_session_text} ${funcName} not flow 4 subflow 3 or 4 goto page claimForm`)
                this.router.navigate(["./claimForm"], { relativeTo: this.route, queryParams: { accident_no: this.claimObj.accident_no, service_location: this.claimObj.service_location, liffId: this.liffId } })
              }
            }
            break;
          }
          this.logger.info(`${this.log_session_text} ${funcName} register flow register chcekOpenTermsAndConditionLine start`);
          if (this.isOpenTermsAndConditionLine()) {
            let ifRedirect = false;
            let iferror = false;
            this.logger.info(`${this.log_session_text} ${funcName} flow register call callTermsAndConditionLine start`);
            await this.callTermsAndConditionLine()
              .then(result => {
                this.logger.info(`${this.log_session_text} ${funcName} flow register callTermsAndConditionLine result:${result}`);
                if (!!result) return ifRedirect = true;
              })
              .catch(error => {
                this.logger.error(`${this.log_session_text} ${funcName} callTermsAndConditionLine error: ${error.message ? error.message : error} , goto page completed status fail`);
                iferror = true;
                this.next.set(true);
                this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
              });
            if (iferror || ifRedirect) break;
          }
          this.logger.info(`${this.log_session_text} ${funcName} register flow register checkpenTermsAndCondition start`);
          if (this.isOpenTermsAndCondition()) {
            let ifRedirect = false;
            let iferror = false;
            this.logger.info(`${this.log_session_text} ${funcName} register flow register call callTermsAndCondition start`);
            await this.callTermsAndCondition()
              .then(result => {
                this.logger.info(`${this.log_session_text} ${funcName} register flow register call callTermsAndCondition result:${result}`);
                if (!!result) return ifRedirect = true;
              })
              .catch(error => {
                this.logger.error(`${this.log_session_text} ${funcName} callTermsAndCondition error: ${error.message ? error.message : error} goto page completed status fail`);
                iferror = true;
                this.next.set(true);
                this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
              });
            if (iferror || ifRedirect) break;
          }
          this.logger.info(`${this.log_session_text} ${funcName} register flow register channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);
          this.logger.info(`${this.log_session_text} ${funcName} register flow register channel.termsAndConditionLine.status:${channel?.termsAndConditionLine?.status}`);

          if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
            channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {            
            const log_customer_id = this.getMaskingService.maskingData(customerUuid)
            this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine start`);
            const isComplete = await this.createUpdateTermAndConditionLine(customerUuid);
            this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine end result:${isComplete}`);
            if (!isComplete) {
              this.next.set(true);
              this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine result not complete go to page completed status fail`);

              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
              break;
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} register flow register channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
          this.logger.info(`${this.log_session_text} ${funcName} register flow register channel.termsAndCondition.status:${channel?.termsAndCondition?.status}`);
          if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT &&
            channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
            this.logger.info(`${this.log_session_text} ${funcName} register flow register channel.termsAndCondition.status:${channel?.termsAndCondition?.status}`);
            const log_customer_id = this.getMaskingService.maskingData(customerUuid)
            this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndCondition start`);
            const isComplete = await this.createUpdateTermAndCondition(customerUuid);
            this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndCondition end result:${isComplete}`);
            if (!isComplete) {
              this.next.set(true);
              this.logger.info(`${this.log_session_text} ${funcName} register flow register customerUuid:${log_customer_id} and call createUpdateTermAndCondition result not complete go to page completed status fail`);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
              break;
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} register flow register check isOpenConsent`);
          if (this.isOpenConsent()) {
            this.logger.info(`${this.log_session_text} ${funcName} register flow register isOpenconsent:true and call callConcent start`);

            await this.callConcent();
            this.next.set(true);
            this.logger.info(`${this.log_session_text} ${funcName} register flow register isOpenconsent:true and call callConcent end and go to page completed`);
            this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure } });
            break;
          }
          this.next.set(true);
          this.logger.info(`${this.log_session_text} ${funcName} register flow register isOpenconsent:true and call callConcent end and go to page completed`);
          this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure } });
          break;
        }
      }
      case ResponseStateRegistration.NOT_REGISTERED: {
        this.state = "not-register";
        this.logger.info(`${this.log_session_text} ${funcName} register flow not-register`);
        this.logger.info(`${this.log_session_text} ${funcName} flow = ${JSON.stringify(this.flow)}`)
        this.logger.info(`${this.log_session_text} ${funcName} register flow not-register isOpenTermsAndConditionLine start`);
        if (this.isOpenTermsAndConditionLine()) {
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} register flow not-register callTermsAndConditionLine start`);
          await this.callTermsAndConditionLine({ forceOpen: true })
            .then(result => {
            this.logger.info(`${this.log_session_text} ${funcName} register flow not-register callTermsAndConditionLine result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow not-register error: ${error.message ? error.message : error} goto page completed status fail`);
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow not-register isOpenTermsAndCondition start`);
        if (this.isOpenTermsAndCondition()) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow not-register isOpenTermsAndCondition : true`);
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} register flow not-register callTermsAndCondition start`);
          await this.callTermsAndCondition({ forceOpen: true })
            .then(result => {
            this.logger.info(`${this.log_session_text} ${funcName} register flow not-register callTermsAndCondition result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow not-register error: ${error.message ? error.message : error}`)
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.next.set(true);
        this.logger.info(`${this.log_session_text} ${funcName} register flow not-register channel.registerFlow:${channel?.registerFlow}`);
        if (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") {
          let parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure });
          this.logger.info(`${this.log_session_text} ${funcName} register flow not-register parameters:${parameters} normal case`);
          if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER) {
            this.logger.info(`${this.log_session_text} ${funcName} register flow not-register unmatch line`)
            parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure, "status": "updateLine", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER });
            this.logger.info(`${this.log_session_text} ${funcName} register flow not-register unmatch line parameters:${parameters}`);
            this.logger.info(`${this.log_session_text} ${funcName} register flow not-register unmatch go to page formUpdateLine`);
            this.VerifyIdentity("../formUpdateLine", parameters);
            break;
          } else {
            this.logger.info(`${this.log_session_text} ${funcName} Normal case`)
            this.VerifyIdentity("../application-form-readonly", parameters);
            break;
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow not-register not flow short renew claim go to page application-form`);
        await this.router.navigate(["application-form"], { relativeTo: this.route });
        break;

      }
      case ResponseStateRegistration.PRE_REGISTERED: {
        this.state = "pre-register";
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register`);
        // use for test in alpha dev w/out sms
        // await this.router.navigate(["./formUpdateLine"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow }, });
        // break;
        this.next.set(false);
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenTermsAndConditionLine start`);
        if (this.isOpenTermsAndConditionLine()) {
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register callTermsAndConditionLine start`);
          await this.callTermsAndConditionLine({ forceOpen: true })
            .then(result => {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register callTermsAndConditionLine result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow pre-register error: ${error.message ? error.message : error}, goto page completed status fail`);
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenTermsAndCondition start`);
        if (this.isOpenTermsAndCondition()) {
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register callTermsAndCondition start`);
          await this.callTermsAndCondition()
            .then(result => {
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register callTermsAndCondition result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow pre-register error: ${error.message ? error.message : error}, goto page completed status fail`);
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register channel.termsAndConditionLine.action: ${channel?.termsAndConditionLine?.action}`);
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register channel.termsAndConditionLine.status: ${channel?.termsAndConditionLine?.status}`);
        if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
          channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {
            const log_customer_id = this.getMaskingService.maskingData(customerUuid)
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndConditionLine start`);

          const isComplete = await this.createUpdateTermAndConditionLine(customerUuid);
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndConditionLine end result:${isComplete}`);
          if (!isComplete) {
            this.next.set(true);
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndConditionLine not completed go to page completed status fail`);
            this.router.navigate(["../completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            break;
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register channel.termsAndCondition.action: ${channel?.termsAndCondition?.action}`);
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register channel.termsAndCondition.status: ${channel?.termsAndCondition?.status}`);
        if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT &&
          channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
            const log_customer_id = this.getMaskingService.maskingData(customerUuid)
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndCondition start`);
          const isComplete = await this.createUpdateTermAndCondition(customerUuid);
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndCondition end result:${isComplete}`);
          if (!isComplete) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register customerUUID: ${log_customer_id} and call createUpdateTermAndCondition not complete go to page completed status fail`);
            this.next.set(true);
            this.router.navigate(["../completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            break;
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register check isOpenConsent`);
        if (this.isOpenConsent()) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:true and call callConcent start`);
          await this.callConcent();
          this.next.set(true);
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:true channel.registerFlow:${channel?.registerFlow}`);
          if (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") {
            let parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure });
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:true parameters:${parameters} normal case`);
            if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER) {
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register unmatch line`)
              parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure, "status": "updateLine", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER });
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register unmatch line parameters:${parameters} and goto page formUpdateLine`);
              this.VerifyIdentity("../formUpdateLine", parameters);
              break;
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} Normal case goto page application-form-readonly`);
              this.VerifyIdentity("../application-form-readonly", parameters);
              break;
            }
            // await this.router.navigate(["application-form-readonly"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow }, });
          } else {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:true not flow short renew claim goto page completed`);
            this.router.navigate(["./completed"], { relativeTo: this.route });
          }
          break;
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:false channel.registerFlow:${channel?.registerFlow}`);
          if (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") {
            let parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure });
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:false parameters:${parameters} normal case`);

            if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER) {
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:false unmatch line`)
              parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure, "status": "updateLine", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER });
              this.VerifyIdentity("../formUpdateLine", parameters);
              break;
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:false Normal case go to page application-form-readonly`);
              this.VerifyIdentity("../application-form-readonly", parameters);
              break;
            }
            // await this.router.navigate(["application-form-readonly"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow }, });
          } else {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register isOpenConsent:false not flow short renew claim goto page completed`);
            this.router.navigate(["./completed"], { relativeTo: this.route });
          }
          break;
        }
      }
      case ResponseStateRegistration.PRE_REGISTERED_PHONE_NOT_MATCH: {
        this.state = "pre-register-phone-unmatch";
        this.logger.info(`${this.log_session_text} register flow pre-register-phone-unmatch`);
        this.next.set(false);
        this.logger.info(`${this.log_session_text} register flow pre-register-phone-unmatch isOpenTermsAndConditionLine start`);
        if (this.isOpenTermsAndConditionLine()) {
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} register flow pre-register-phone-unmatch callTermsAndConditionLine start`);
          await this.callTermsAndConditionLine({ forceOpen: true })
            .then(result => {
            this.logger.info(`${this.log_session_text} register flow pre-register-phone-unmatch callTermsAndConditionLine result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch error: ${error.message ? error.message : error}, goto page completed status fail`);
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenTermsAndCondition start`);
        if (this.isOpenTermsAndCondition()) {
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch callTermsAndCondition start`);
          await this.callTermsAndCondition()
            .then(result => {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch callTermsAndCondition result:${result}`);

              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch callTermsAndCondition error: ${error.message ? error.message : error}, goto page completed status fail`);
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch channel.termsAndConditionLine.status:${channel?.termsAndConditionLine?.status}`);
        if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
          channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {
          const log_customer_id = this.getMaskingService.maskingData(customerUuid)
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine start`);
          const isComplete = await this.createUpdateTermAndConditionLine(customerUuid);
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine end result:${isComplete}`);
          if (!isComplete) {
            this.next.set(true);
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine not completed, goto page completed status fail`);
            this.router.navigate(["../completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            break;
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch channel.termsAndCondition.status:${channel?.termsAndCondition?.status}`);
        if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT &&
          channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
            const log_customer_id = this.getMaskingService.maskingData(customerUuid)
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine start`);
            const isComplete = await this.createUpdateTermAndCondition(customerUuid);
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine end result:${isComplete}`);
          if (!isComplete) {
            this.next.set(true);
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch customerUuid:${log_customer_id} and call createUpdateTermAndConditionLine not completed, goto page completed status fail`);
            this.router.navigate(["../completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            break;
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch check isOpenConsent`);
        if (this.isOpenConsent()) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:true and call callConcent start`);
          await this.callConcent();
          this.next.set(true);
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:true channel.registerFlow:${channel?.registerFlow}`);
          if (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") {
            let parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure });
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:true parameters:${parameters} normal case`);
            if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER) {
              this.logger.info(`${this.log_session_text} ${funcName} unmatch line`)
              parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure, "status": "updateLine", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER });
              this.logger.info(`${this.log_session_text} ${funcName} unmatch line parameters:${parameters} and goto page formUpdateLine`);
              this.VerifyIdentity("../formUpdateLine", parameters);
              break;
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} Normal case, goto page application-form-readonly`);
              this.VerifyIdentity("../application-form-readonly", parameters);
              break;
            }
            // await this.router.navigate(["application-form-readonly"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow }, });
          } else {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch registerFlow not flow short renew claim goto page mobile-verify`);
            const identity: Identity = {
              id_card: idNo,
              phone_number: "",
              update_chanel_identity_flag: false,
            };
            const log_identity = {
              ...identity,
              id_card: this.getMaskingService.maskingData(identity.id_card)
            }
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch registerFlow not flow short renew claim identity:${JSON.stringify(log_identity)}`);
            this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
            this.next.set(true);
            this.router.navigate(["mobile-verify"], { relativeTo: this.route, queryParams: { type: "notmatch" } });
            break;
          }
          break;
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false channel.registerFlow:${channel?.registerFlow}`);
          if (channel.registerFlow == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") {
            let parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure });
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false parameters:${parameters} normal case`);
            if (channel.refCode && res_verfify == ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER) {
              this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false unmatch line, goto page formUpdateLine`);
              parameters = JSON.stringify({ ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure, "status": "updateLine", "code": ResponseCheckRegisterAndValidate.UNMATCH_IN_CASE_LINE_REGISTER });
              this.VerifyIdentity("../formUpdateLine", parameters);
              break;
            } else {
              this.logger.info(`${this.log_session_text} ${funcName} flow pre-register-phone-unmatch isOpenConsent:false Normal case, goto page application-form-readonly`);
              this.VerifyIdentity("../application-form-readonly", parameters);
              break;
            }
            // await this.router.navigate(["application-form-readonly"], { relativeTo: this.route, queryParams: { ref: this.ref, liff_motor: this.liff_motor, flow: this.flow }, });
          } else {
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false not flow short renew claim goto page mobile-verify`);
            const identity: Identity = {
              id_card: idNo,
              phone_number: "",
              update_chanel_identity_flag: false,
            };

            const log_identity = {
              ...identity,
              id_card: this.getMaskingService.maskingData(identity.id_card)
            }
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false identity:${JSON.stringify(log_identity)}`);
            this.lineStateAction.sinkIdentity.next(new SetIdentityAction(identity));
            this.next.set(true);
            this.logger.info(`${this.log_session_text} ${funcName} register flow pre-register-phone-unmatch isOpenConsent:false go to page mobile-verify type notmatch`);

            this.router.navigate(["mobile-verify"], { relativeTo: this.route, queryParams: { type: "notmatch" } });
            break;
          }
          break;
        }

      }
      case ResponseStateRegistration.OTHER_ERROR: {
        this.next.set(true);
        this.logger.info(`${this.log_session_text} ${funcName} register flow other error and goto page completed status fail`);
        this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00007" } });
        break;
      }
    }
  }

  async flowTelemed(registerStatus, customer_id) {
    const funcName = 'flowTelemed'
    const telemedLineInfo = this.telemedStateActionService.lineInfo;
    const channel = this.lineStateAction.channelStateInfo;
    telemedLineInfo.isActiveFlow = true;
    this.logger.info(`${this.log_session_text} ${funcName} telemed start`);
    this.logger.info(`${this.log_session_text} ${funcName} telemed telemedLineInfo: ${JSON.stringify(telemedLineInfo)}`);
    this.logger.info(`${this.log_session_text} ${funcName} telemed channel: ${JSON.stringify(channel)}`);

    if (telemedLineInfo.history) {
      this.logger.info(`${this.log_session_text} ${funcName} telemed telemedLineInfo.history true`);
      this.next.set(true);
      this.displayLayout = false;
      return this.router.navigate(["dazHistory"], { relativeTo: this.route, queryParams: { history: telemedLineInfo.history } });
    }
    this.logger.info(`${this.log_session_text} ${funcName} telemed telemedLineInfo.history false`);
    this.logger.info(`${this.log_session_text} ${funcName} telemed registerStatus: ${registerStatus}`);
    let registerType = null;
    if (registerStatus == ResponseStateRegistration.REGISTERED_ALREADY) registerType = 1;
    else if (registerStatus == ResponseStateRegistration.PRE_REGISTERED_PHONE_NOT_MATCH ||
      registerStatus == ResponseStateRegistration.PRE_REGISTERED) registerType = 2;
    else if (registerStatus == ResponseStateRegistration.PRE_REGISTERED ||
      registerStatus == ResponseStateRegistration.PRE_REGISTERED_PHONE_NOT_MATCH) registerType = 2;
    else if (registerStatus == ResponseStateRegistration.NOT_REGISTERED) registerType = 3;
    else registerType = 3;
    channel.registerType = registerType;
    this.logger.info(`${this.log_session_text} ${funcName} telemed channel.registerType: ${registerType}`);
    channel.identityId = customer_id;
    const log_customer_id = this.getMaskingService.maskingData(customer_id)
    this.logger.info(`${this.log_session_text} ${funcName} telemed channel.identityId: ${log_customer_id}`);

    switch (registerStatus) {
      case ResponseStateRegistration.REGISTERED_ALREADY: {
        this.logger.info(`${this.log_session_text} ${funcName} register flow telemed register REGISTERED_ALREADY start`);
        const responseAdditional = await this.additionalServiceRegistrationTelemed(1).then(res => { return res });
        this.logger.info(`${this.log_session_text} ${funcName} responseAdditional:${responseAdditional}`);
        if (!responseAdditional) {
          this.logger.info(`${this.log_session_text} ${funcName} responseAdditional alert`);
          alert('เกิดข้อผิดพลาด บันทึกบริการเสริมไม่สำเร็จ(1)');
          return await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail' } });
        }
        if (this.isOpenTermsAndConditionLine()) {
          this.logger.info(`${this.log_session_text} ${funcName} isOpenTermsAndConditionLine start`);
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} telemed customer_id: ${log_customer_id} callTermsAndConditionLine start`);

          await this.callTermsAndConditionLine({ "customer_id": customer_id, "terms_and_condition_name": "telemed_line" })
            .then(result => {
              this.logger.info(`${this.log_session_text} ${funcName} telemed callTermsAndConditionLine result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} callTermsAndConditionLine error: ${error.message ? error.message : error}`)
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
            });
        }
        if (this.isOpenTermsAndCondition()) {
          this.logger.info(`${this.log_session_text} ${funcName} isOpenTermsAndCondition start`);
          let ifRedirect = false;
          let iferror = false;
          this.logger.info(`${this.log_session_text} ${funcName} telemed customer_id: ${log_customer_id} callTermsAndCondition start`);
          await this.callTermsAndCondition({ "customer_id": customer_id, "terms_and_condition_name": "telemed" })
            .then(result => {
              this.logger.info(`${this.log_session_text} ${funcName} telemed callTermsAndCondition result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} telemed callTermsAndCondition error: ${error.message ? error.message : error}`)
              iferror = true;
              this.next.set(true);
              return this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
            });
        }
        if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
          channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {
          this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndConditionLine start`);
          const isComplete = await this.createUpdateTermAndConditionLine();
          this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndConditionLine isComplete:${isComplete}`);

          if (!isComplete) {
            this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndConditionLine false`);
            this.next.set(true);
            this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            break;
          }
        }
        if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT &&
          channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
          this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndCondition start`);
          const isComplete = await this.createUpdateTermAndCondition();
          this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndCondition isComplete:${isComplete}`);

          if (!isComplete) {
            this.logger.info(`${this.log_session_text} ${funcName} createUpdateTermAndCondition false`);
            this.next.set(true);
            return await this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
          }
        }
        this.logger.info(`${this.log_session_text} ${funcName} callConsent start`);
        this.callConcent().then(resp => {
          if (!resp) {
            this.next.set(true);
            this.router.navigate(["dazForm"], { relativeTo: this.route });
          }
        });
        break;
      }
      case ResponseStateRegistration.PRE_REGISTERED:
      case ResponseStateRegistration.PRE_REGISTERED_PHONE_NOT_MATCH: {
        this.logger.info(`${this.log_session_text} ${funcName} register flow telemed pre-register-phone-unmatch`);
        this.state = 'pre-register';
        const responseAdditional = await this.additionalServiceRegistrationTelemed(2).then(res => { this.logger.info(res); return res });
        this.logger.info(`${this.log_session_text} ${funcName} register flow telemed responseAdditional:${responseAdditional}`);
        if (!responseAdditional) {
          this.logger.info(`${this.log_session_text} ${funcName} register flow telemed additionalServiceRegistrationTelemed false`);
          alert('เกิดข้อผิดพลาด บันทึกบริการเสริมไม่สำเร็จ(1)');
          return await this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail' } });
        }
        let requestBody = {
          // "channel_identity": channel.channel_identity,
          "application_channel_reference": channel.application_channel_reference,
          "electronic_channel": channel.electronic_channel
        }
        this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine body:${JSON.stringify(requestBody)}`);

        this.verifyCustomerService.apiGetLeadCustomerRegistrationByLine(requestBody).subscribe(async (response) => {
        this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine success`);
          let customerInfo = null;
          if (response && response.data) {
            this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine have response data`);
            customerInfo = {
              "id_card": response.data["id_card"],
              "first_name": response.data["first_name"],
              "last_name": response.data['last_name'],
            }
            const log_customerInfo = {
              ...customerInfo,
              id_card : this.getMaskingService.maskingData(customerInfo.id_card),
              first_name : this.getMaskingService.maskingData(customerInfo.first_name),
              last_name : this.getMaskingService.maskingData(customerInfo.last_name)
            }
            this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine customerInfo: ${JSON.stringify(log_customerInfo)}`);

          }
          if (this.isOpenTermsAndConditionLine()) {
            let ifRedirect = false;
            let iferror = false;
            this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine isOpenTermsAndConditionLine true`);
            this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine callTermsAndConditionLine start`);
            await this.callTermsAndConditionLine({ "terms_and_condition_name": "telemed_line" })
              .then(result => {
                this.logger.info(`${this.log_session_text} ${funcName} register flow telemed call apiGetLeadCustomerRegistrationByLine callTermsAndConditionLine result:${result}`);
                if (!!result) return ifRedirect = true;
              })
              .catch(error => {
                this.logger.error(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine error: ${error.message ? error.message : error}`)
                iferror = true;
                this.next.set(true);
                this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
              });
          }
          if (this.isOpenTermsAndCondition()) {
            let ifRedirect = false;
            let iferror = false;
            this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine isOpenTermsAndCondition:true`);
            await this.callTermsAndCondition({ "terms_and_condition_name": "telemed" })
              .then(response => { 
                this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine callTermsAndCondition response:${response}`);
                if (!!response) return ifRedirect = true; 
              })
              .catch(error => {
                this.logger.error(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine callTermsAndCondition error: ${error.message ? error.message : error}`)
                iferror = true;
                this.next.set(true);
                return this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndCondition error" } })
              });
          }
          this.logger.info(`${this.log_session_text} ${funcName} channel.termsAndConditionLine.action:${channel?.termsAndConditionLine?.action}`);
          this.logger.info(`${this.log_session_text} ${funcName} channel.termsAndConditionLine.status:${channel?.termsAndConditionLine?.status}`);

          if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == ActionStatusLine.ACCEPT &&
            channel.termsAndConditionLine.status != ResponseStatusLine.COMPLETED) {
            this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndConditionLine start`);

            const isComplete = await this.createUpdateTermAndConditionLine();
            this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndConditionLine isComplete:${isComplete}`);

            if (!isComplete) {
              this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndConditionLine isComplete false goto page completed status fail`);
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} channel.termsAndCondition.action:${channel?.termsAndCondition?.action}`);
          this.logger.info(`${this.log_session_text} ${funcName} channel.termsAndCondition.status:${channel?.termsAndCondition?.status}`);
          if (channel && channel.termsAndCondition && channel.termsAndCondition.action == ActionStatus.ACCEPT &&
            channel.termsAndCondition.status != ResponseStatus.COMPLETED) {
              this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndCondition start`);
              const isComplete = await this.createUpdateTermAndCondition();
              this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndCondition isComplete:${isComplete}`);
            if (!isComplete) {
              this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine createUpdateTermAndCondition isComplete false goto page completed status fail`);
              this.next.set(true);
              return await this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { status: "fail", code: "E00003" } });
            }
          }
          this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine callConcent start`);
          this.callConcent(customerInfo).then(resp => {
          this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine callConcent resp:${resp}`);
            if (!resp) {
              this.logger.info(`${this.log_session_text} ${funcName} apiGetLeadCustomerRegistrationByLine callConcent goto page dazForm`);
              this.next.set(true);
              this.router.navigate(["dazForm"], { relativeTo: this.route });
            }
          });
        });

        break;
      }
      case ResponseStateRegistration.NOT_REGISTERED: {
        this.logger.info(`${this.log_session_text} ${funcName} register telemed flow not-register started`);
        if (this.isOpenTermsAndConditionLine()) {
          this.logger.info(`${this.log_session_text} ${funcName} register telemed flow not-register callTermsAndConditionLine start`);
          let ifRedirect = false;
          let iferror = false;
          await this.callTermsAndConditionLine({ forceOpen: true })
            .then(result => {
              this.logger.info(`${this.log_session_text} ${funcName} register telemed flow not-register callTermsAndConditionLine result:${result}`);
              if (!!result) return ifRedirect = true;
            })
            .catch(error => {
              this.logger.error(`${this.log_session_text} ${funcName} register telemed flow not-register error: ${error.message ? error.message : error}`)
              iferror = true;
              this.next.set(true);
              this.router.navigate(["./completed"], { relativeTo: this.route, queryParams: { "status": "fail", "code": "termsAndConditionLine error" } })
            });
          if (iferror || ifRedirect) break;
        }
        this.logger.info(`${this.log_session_text} ${funcName} register telemed flow not-register goto page dazForm`);
        this.next.set(true);
        this.router.navigate(["dazForm"], { relativeTo: this.route });
        break;
      }
    }
  }

  additionalServiceRegistrationTelemed(registerType: number): Promise<boolean> {
    const funcName = 'additionalServiceRegistrationTelemed'
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    return new Promise((resolve, reject) => {
      try {
        this.logger.info(`${this.log_session_text} ${funcName} channel: ${JSON.stringify(this.lineStateAction?.channelStateInfo)}`);
        const channel = this.lineStateAction.channelStateInfo;
        this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow: ${channel.registerFlow}`);
        if (channel.registerFlow == "telemed") {
          this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow: telemed start`);

          const identity = this.lineStateAction.identityStateInfo;
          const { electronic_channel, channel_identity, application_channel_reference } = channel
          this.logger.info(`${this.log_session_text} ${funcName} electronic_channel: ${electronic_channel}`);
          this.logger.info(`${this.log_session_text} ${funcName} application_channel_reference: ${application_channel_reference}`);

          let phone_number = null;
          if (identity) {
            this.logger.info(`${this.log_session_text} ${funcName} identity have value`);
            phone_number = identity.phone_number;
            const log_phone_number = this.getMaskingService.maskingData(phone_number);
            this.logger.info(`${this.log_session_text} ${funcName} phone_number:${log_phone_number}`);
          }
          let body = {
            "registration_reference": phone_number,
            "electronic_channel": electronic_channel,
            "application_channel_reference": application_channel_reference
          }
          // register type 1 = register already
          if (registerType == 1) {
            // body['channel_identity'] = channel_identity;
          }
          let log_body = {
            ...body,
            registration_reference: this.getMaskingService.maskingData(body.registration_reference)
          }
          this.logger.info(`${this.log_session_text} ${funcName} body apiInsert:${JSON.stringify(log_body)}`);
          this.formAdditionalServiceRegistration.apiInsert(body).subscribe(response => {
            this.logger.info(`${this.log_session_text} ${funcName} apiInsert response:${response?.state_code}`);
            if (response && response.state_code != "S20000") {
              this.logger.info(`${this.log_session_text} ${funcName} apiInsert end`);
              return resolve(false);
            }
          });
        }
        this.logger.info(`${this.log_session_text} ${funcName} end`);
        return resolve(true);
      }
      catch (error) {
        this.logger.error(`${this.log_session_text} ${funcName} error: ${error.message ? error.message : error}`)
        resolve(false);
      }
    })
  }

  async setMaintainance() {

    const funcName = 'setMaintainance'
    this.logger.info(`${this.log_session_text}:${funcName}:start`);

    let result = false;
    try {
      this.maintainanceService.apiGetMaintainance().subscribe((res: any) => {
        if (res) {
          const { timestamp_start, timestamp_end, timestamp_now } = res;
          if (timestamp_start && timestamp_end && timestamp_now) {
            if (
              timestamp_now >= timestamp_start &&
              timestamp_now <= timestamp_end
            ) {
              const dateEnd = new Date(timestamp_end);
              const splitDateEndTh = dateEnd
                .toLocaleDateString("th-TH")
                .split("/");
              if (splitDateEndTh.length === 3) {
                const months = {
                  1: "มกราคม",
                  2: "กุมภาพันธ์",
                  3: "มีนาคม",
                  4: "เมษายน",
                  5: "พฤษภาคม",
                  6: "มิถุนายน",
                  7: "กรกฎาคม",
                  8: "สิงหาคม",
                  9: "กันยายน",
                  10: "ตุลาคม",
                  11: "พฤศจิกายน",
                  12: "ธันวาคม",
                };
                let d = splitDateEndTh[0];
                let m = months[splitDateEndTh[1]];
                let y = splitDateEndTh[2];
                let hh = dateEnd.getHours();
                let mm = dateEnd.getMinutes().toString();
                mm = +mm < 10 ? "0" + mm : mm;
                result = true;
                this.buyInsuranceOnlineClosedFlag.set(true);
                this.buyInsuranceOnlineClosedDesc.set(`ขออภัยระบบอยู่ระหว่างการปิดปรับปรุง โดยท่านสามารถใช้บริการอีกครั้งได้<br>วันที่ ${d} ${m} ${y} เวลา ${hh}:${mm}`);
              }
            }
          }
        }
      });
    } catch (error) {
      this.logger.error(`${this.log_session_text}:${funcName}:error:${error.message ? error.message : error}`);
    }

    this.logger.info(`${this.log_session_text}:${funcName}:result:${result}`);
    this.logger.info(`${this.log_session_text}:${funcName}:end`);

    return result;
  }

  setSessionStorage(sessionRef) {
    const funcName = "setSessionStorage"
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    const channel = this.lineStateAction.channelStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const customer = this.lineStateAction.customerStateInfo;
    const telemed = this.telemedStateActionService.lineInfo;

    let json = {
      channel: channel,
      identity: identity,
      customer: customer,
      telemed: telemed,
      state: this.state,
      substate: this.substate,
      ref: this.ref,
      liff_motor: this.liff_motor,
      flow: this.flow,
      classify_insure: this.classify_insure,
    };
    sessionStorage.setItem(sessionRef, JSON.stringify(json));
    this.logger.info(`${this.log_session_text} ${funcName} end`);
  }

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  async VerifyIdentity(nextNavigate, queryParams = null): Promise<boolean> {
    const funcName = 'VerifyIdentity'
    this.logger.info(`${this.log_session_text} ${funcName} started`);
    this.logger.info(`${this.log_session_text} ${funcName} Verify Identify: ${JSON.stringify(nextNavigate)}`)
    return new Promise((resolve, reject) => {
      const channel = this.lineStateAction.channelStateInfo;
      if (!channel) {
        this.logger.info(`${this.log_session_text} ${funcName} condition 1: (!channel)`);
        return resolve(false);
      }
      if (channel.verify_identity_token) {
        this.logger.info(`${this.log_session_text} ${funcName} condition 2: (channel.verify_identity_token)`);
        return resolve(false);
      }
      const telemed = () => {
        // return (channel.registerFlow == "telemed" && channel.subflow == "2" && channel.registerType == 3)
        // telemed ต้องเช็ค registerType ด้วย จึงต้องทำหลัง api check register
        return false;
      }
      const renew = () => {
        return (channel.registerFlow == "renew" && (channel.subChannel == "5" || channel.subChannel == "6" || channel.subChannel == "8"))
      }
      const short = () => {
        return (channel.registerFlow == "short" && (channel.subChannel == "5" || channel.subChannel == "6"))
      }
      const claim = () => {
        return (channel.registerFlow == "claim" && (channel.subChannel == "5" || channel.subChannel == "6"))
      }
      this.logger.info(`${this.log_session_text} ${funcName} check condition verify identity`)
      if ((telemed() || renew() || short()) || claim()) {
        let log_queryParams = queryParams ? JSON.stringify(queryParams) : null;
        this.logger.info(`${this.log_session_text} ${funcName} open verify identity goto page verifyIdentityForm :${log_queryParams}`);
        this.next.set(true);
        this.router.navigate(["verifyIdentityForm"], { relativeTo: this.route, queryParams: { navigate: nextNavigate, queryParams: queryParams } });
        this.logger.info(`${this.log_session_text} ${funcName} condition 3: ((telemed() || renew() || short()) || claim())`);
        return resolve(true);
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} condition 4: (else)`);
        this.logger.info(`${this.log_session_text} ${funcName} condition invalid`)
        return resolve(false);
      }
    })
  }
}
